import { Info } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';
import { EmployeeFieldsEditor } from '@/components/employees/EmployeeFieldsEditor';

export default function EmployeeFieldsSettingsPage() {
  return (
    <div className="space-y-5 fade-in max-w-3xl">
      <PageHeader
        title="Customize Employee Fields"
        subtitle="Choose which fields appear on the Add/Edit Employee form"
        breadcrumb={[{ label: 'Settings', href: '/settings' }, { label: 'Customize Employee Fields' }]}
      />

      <div className="flex items-start gap-2 px-4 py-3 rounded-[10px] bg-blue-50 dark:bg-blue-900/20 border border-blue-200 text-[13px] text-blue-700">
        <Info size={14} className="mt-0.5 shrink-0"/>
        <p>Locked fields (name, bank details, employment type, joining date) are always required because payroll and attendance depend on them. Everything else is optional — turn on only what your organization actually collects. You can also edit this from the Add Employee page itself via the pencil icon.</p>
      </div>

      <EmployeeFieldsEditor/>
    </div>
  );
}
